
import { Directive } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import * as moment from 'moment';

@Directive({
    selector: '[bindQueryParams]',
})
export class BindQueryParamsDirective {
    constructor(private ngControl: ControlContainer) {
    }

    ngOnInit() {
        if (location.search) {
            const queryParams = new URLSearchParams(location.search);

            let params = {};

            for (let [key, val] of queryParams) {
                let parsedVal = JSON.parse(val);
                if (parsedVal) {
                    if (typeof parsedVal === 'object' && parsedVal.type === 'date-range') {
                        parsedVal.start = moment(parsedVal.start) || moment().subtract(1, 'days');
                        parsedVal.end = moment(parsedVal.end) || moment();
                    }

                    params[key] = parsedVal;
                }
            }

            this.ngControl.control.patchValue(params);
        }
    }
}